import React from 'react'

import { Box } from '@mui/material'

import CortexChatPanel from './CortexChatPanel'
import { getOrCreateAssistantTabId } from '../../auth'

// Native replacement for ConditionalRenderAssistant mode="fullTab" +
// kwik-assistant's embedded Chat, used in Main's "Cortex" nav tab. Scoped to
// a persistent per-login-session id (survives tab switches/reloads via
// sessionStorage, regenerated only on next login) rather than any ticket -
// independent of the sidebar surface's conversation.
const CortexTabAssistant = () => {
    return (
        <Box height="100%">
            <CortexChatPanel
                rawExternalId={getOrCreateAssistantTabId()}
                useTicketLock={false}
                canSendMessage
            />
        </Box>
    )
}

export default CortexTabAssistant
